import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchClientOutstandingOrders } from '@/renderer/services/accommodationService';

export function useClientOutstandingOrders(
  clientId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.accommodation.outstandingOrders(clientId ?? ''),
    queryFn: () => fetchClientOutstandingOrders(clientId!),
    enabled: !!clientId,
  });
}
